import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Input as BaseInput } from '@alfa-bank/site-input';

import type { TBirthdayField, IDeps } from './models';
import { BirthdayField as Component } from './birthday-field';
import styles from './styles/styles.css';

// Компоненту не требуется функционал стайлера
// eslint-disable-next-line styler/check-styler
export const BirthdayField = createWidget<IDeps, TBirthdayField>({
    BaseInput,
    styles,
})(Component);
